import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const CancelSupportMeeting = createAsyncThunk(
    'engagementMeetings/cancelSupportMeeting',
    async (
        {
            meetingEventId,
            applyToFollowing,
        }: { meetingEventId: number; applyToFollowing?: boolean },
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.delete(
                `/api/Marketplace/MarketplaceMeetings/${meetingEventId}${
                    applyToFollowing ? '?applyToFollowing=true' : ''
                }`
            );

            if (response.status !== 200 && response.status !== 204) {
                createNotification(
                    'Could not remove the meeting at the moment.',
                    'error'
                );
                throw new Error('Failed to cancel support meeting');
            }

            createNotification('Meeting removed successfully.', 'success');
            return { meetingEventId };
        } catch (error) {
            createNotification(
                'An error occurred while removing the meeting.',
                'error'
            );
            throw error;
        }
    }
);
